import {uploadBytes, uploadString} from "@firebase/storage";
import {firebaseStorage, storageRef} from "../../firebase/client-app";

export {
    uploadSingleImageFileDataUrl,
    uploadSingleImageFileRaw,
}

const uploadSingleImageFileDataUrl = (fullFilePath, imageBase64Data, metaData) => {
    const fileReference = storageRef(firebaseStorage, fullFilePath);
    return uploadString(fileReference, imageBase64Data, 'data_url', metaData);
}

const uploadSingleImageFileRaw = (fullFilePath, file, metaData?) => {
    const fileReference = storageRef(firebaseStorage, fullFilePath);
    return uploadBytes(fileReference, file, metaData);
}
